/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from 'react'
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Button,
  Stack
} from '@chakra-ui/react'
import { NavLink, useLocation} from "react-router-dom";


export default function NavDrawer({ Disclosure, btnRef }) {
  const { search } = useLocation();
  return (
    <>
      <Drawer
        isOpen={Disclosure.isOpen}
        placement='right'
        onClose={Disclosure.onClose}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader align='center'>Navigation</DrawerHeader>

          <DrawerBody>
            <Stack direction='column' spacing={4} align='center'>
              <Button as={NavLink} to={`/${search}`}
                w='full' onClick={Disclosure.onClose} style={({ isActive }) => {
                  return {
                    color: isActive ? "red" : "",
                  };
                }}>Features</Button>
              <Button as={NavLink} to={`editor${search}`}
                w='full' onClick={Disclosure.onClose} style={({ isActive }) => {
                  return {
                    color: isActive ? "red" : "",
                  };
                }}>Editor</Button>
              <Button as={NavLink} to={`reports${search}`}
                w='full' onClick={Disclosure.onClose} style={({ isActive }) => {
                  return {
                    color: isActive ? "red" : "",
                  };
                }}>Reporting</Button>
              <Button as={NavLink} to={`admin${search}`}
                w='full' onClick={Disclosure.onClose} style={({ isActive }) => {
                  return {
                    color: isActive ? "red" : "",
                  };
                }}>Administration</Button>
              <Button as={NavLink} to={`contact${search}`}
                w='full' onClick={Disclosure.onClose} style={({ isActive }) => {
                  return {
                    color: isActive ? "red" : "",
                  };
                }}>Contact Us</Button>
            </Stack>
          </DrawerBody>

          {/* <DrawerFooter>
              <Button variant='outline' mr={3} onClick={Disclosure.onClose} style={({ isActive }) => {
              return {
                display: "block",
                margin: "1rem 0",
                color: isActive ? "red" : "",
              };
            }}>
                Cancel
              </Button>
              <Button colorScheme='blue'>Save</Button>
            </DrawerFooter> */}
        </DrawerContent>
      </Drawer>
    </>
  )
}